export default __webpack_public_path__ + "static/vienna-240fd588e120fa22221ff7856a693738.png";